const chapter = {
  id: 'biotech-applications',
  slug: 'biotech-applications',
  subject: 'biology',
  subjectLabel: 'Biology',
  exam: 'NEET',
  title: {
    english: 'Biotechnology and its Applications',
        hindi: 'जैव प्रौद्योगिकी और उसके अनुप्रयोग',
  },
  estReadMinutes: 50,
  difficulty: {
    english: 'Easy-Medium',
        hindi: 'आसान-मध्यम',
  },
  weightage: {
    english: '3 questions in NEET',
        hindi: 'NEET में 3 प्रश्न दो व्यापक प्रकार: **मेरिस्टेमेटिक** (विभाजन) + **स्थायी** (कोई विभाजन नहीं)। **मेरिस्टेम्स**:',
  },
  syllabusTags: ['Biotechnology', 'NEET', 'Class-12'],
  sections: [
    {
      id: 'sectors',
      title: {
        english: 'Three Critical Areas',
        hindi: 'तीन महत्वपूर्ण क्षेत्र',
      },
      blocks: [
        {
          type: 'list',
          items: [
            {
              english: 'Biotech principally applied to: **(i) therapeutics, (ii) diagnostics, (iii) genetically engineered crops** + **processed food & bioremediation + waste treatment + energy production**.',
        hindi: 'बायोटेक मुख्य रूप से लागू होता है: **(i) चिकित्सीय, (ii) निदान, (iii) आनुवंशिक रूप से इंजीनियर फसलें** + **प्रसंस्कृत भोजन और बायोरेमेडिएशन + अपशिष्ट उपचार + ऊर्जा उत्पादन**।',
            },
            {
              english: 'Three sectors: **agriculture, medicine, industry**.',
        hindi: 'तीन क्षेत्र: **कृषि, चिकित्सा, उद्योग**।',
            },
          ],
        },
      ],
    },
    {
      id: 'agriculture',
      title: {
        english: 'Biotechnology in Agriculture',
        hindi: 'कृषि में जैव प्रौद्योगिकी',
      },
      blocks: [
        {
          type: 'list',
          items: [
            {
              english: 'Three options to ↑ food production:',
        hindi: 'खाद्य उत्पादन के लिए तीन विकल्प:',
            },
            {
              english: '• Agrochemical-based (inorganic chemicals — costly, hazardous).',
        hindi: '• कृषि रसायन आधारित (अकार्बनिक रसायन - महंगा, खतरनाक)।',
            },
            {
              english: '• Organic agriculture.',
        hindi: '• जैविक कृषि।',
            },
            {
              english: '• **Genetically engineered crops (GM crops)** — most promising.',
        hindi: '• **आनुवंशिक रूप से इंजीनियर की गई फसलें (जीएम फसलें)** - सबसे आशाजनक।',
            },
            {
              english: 'Aims of GM crops:',
        hindi: 'जीएम फसलों के उद्देश्य:',
            },
            {
              english: '• Tolerance to abiotic stress (cold, drought, salt, heat).',
        hindi: '• अजैविक तनाव (ठंड, सूखा, नमक, गर्मी) के प्रति सहनशीलता।',
            },
            {
              english: '• Reduced reliance on chemical pesticides (**Bt crops**).',
        hindi: '• रासायनिक कीटनाशकों (**बीटी फसलें**) पर निर्भरता कम हुई।',
            },
            {
              english: '• Reduced post-harvest losses (Flavr Savr tomato).',
        hindi: '• कटाई के बाद होने वाले नुकसान में कमी (फ्लेवर सेवर टमाटर)।',
            },
            {
              english: '• Increased efficiency of mineral usage (prevents early soil exhaustion).',
        hindi: '• खनिज उपयोग की बढ़ी हुई दक्षता (मिट्टी की शीघ्र थकावट को रोकती है)।',
            },
            {
              english: '• Enhanced nutritional value (**Golden Rice** with vitamin A precursor β-carotene).',
        hindi: '• उन्नत पोषण मूल्य (**गोल्डन राइस** विटामिन ए अग्रदूत β-कैरोटीन के साथ)।',
            },
            {
              english: '• Custom-tailored plants for alternative resources to industries (starch, fuels, pharma).',
        hindi: '• उद्योगों (स्टार्च, ईंधन, फार्मा) के वैकल्पिक संसाधनों के लिए कस्टम-अनुरूप संयंत्र। **बीटी कपास (बैसिलस थुरिंजिएन्सिस)**:',
            },
          ],
        },
        {
          type: 'list',
          items: [
            {
              english: '**Bt cotton (Bacillus thuringiensis)**:',
        hindi: '**बीटी कपास (बैसिलस थुरिंजिएन्सिस)**:',
            },
            {
              english: '• *B. thuringiensis* forms **Cry protein (toxin) crystals** during sporulation. Inactive **protoxin**; activated by alkaline pH of insect midgut → binds midgut epithelium → osmotic lysis → death.',
        hindi: '• *बी. थुरिंजिएन्सिस* स्पोरुलेशन के दौरान **क्राई प्रोटीन (टॉक्सिन) क्रिस्टल** बनाता है। निष्क्रिय **प्रोटोक्सिन**; कीट मध्य आंत के क्षारीय पीएच द्वारा सक्रिय → मध्य आंत उपकला को बांधता है → आसमाटिक लसीका → मृत्यु।',
            },
            {
              english: '• **Bt toxin genes**: cryIAc, cryIIAb → **cotton bollworms**; cryIAb → **corn borer**.',
        hindi: '• **बीटी विष जीन**: क्रायआईएसी, क्राआईआईएबी → **कपास बॉलवर्म**; क्रायआईएबी → **मकई छेदक**।',
            },
            {
              english: '• Specific insect group; safe to other organisms.',
        hindi: '• विशिष्ट कीट समूह; अन्य जीवों के लिए सुरक्षित. **कीट-प्रतिरोधी पौधे - आरएनएआई**:',
            },
            {
              english: '**Pest-resistant plants — RNAi**:',
        hindi: '**कीट-प्रतिरोधी पौधे - आरएनएआई**:',
            },
            {
              english: '• Nematode *Meloidogyne incognita* infects tobacco roots → ↓ yield.',
        hindi: '• नेमाटोड *मेलोइडोगाइन इन्कॉग्निटा* तंबाकू की जड़ों → ↓ उपज को संक्रमित करता है।',
            },
            {
              english: '• Strategy: introduce nematode-specific genes into host plant via Agrobacterium → produce **dsRNA** → silences specific mRNA in nematode (RNA interference) → nematode cannot survive.',
        hindi: '• रणनीति: एग्रोबैक्टीरियम के माध्यम से मेजबान पौधे में नेमाटोड-विशिष्ट जीन पेश करें → उत्पादन **dsRNA** → नेमाटोड में विशिष्ट एमआरएनए को शांत करें (आरएनए हस्तक्षेप) → नेमाटोड जीवित नहीं रह सकते हैं।',
            },
          ],
        },
      ],
    },
    {
      id: 'medicine',
      title: {
        english: 'Biotechnology in Medicine',
        hindi: 'चिकित्सा में जैव प्रौद्योगिकी',
      },
      blocks: [
        {
          type: 'list',
          items: [
            {
              english: '**1. Genetically engineered insulin** —',
        hindi: '**1. आनुवंशिक रूप से इंजीनियर इंसुलिन** -',
            },
            {
              english: '• Mature human insulin = A chain (21 aa) + B chain (30 aa) connected by S-S bonds; assembled from proinsulin by removal of **C peptide**.',
        hindi: '• परिपक्व मानव इंसुलिन = एस-एस बांड द्वारा जुड़ी एक श्रृंखला (21 एए) + बी श्रृंखला (30 एए); **सी पेप्टाइड** को हटाकर प्रोइन्सुलिन से इकट्ठा किया गया।',
            },
            {
              english: '• **Eli Lilly (1983)** — synthesised separate A & B chain DNA sequences in *E. coli* plasmids → produced separately → linked by disulphide bonds → first **Humulin** (human-identical recombinant insulin).',
        hindi: '• **एली लिली (1983)** - *ई में अलग ए और बी श्रृंखला डीएनए अनुक्रम संश्लेषित। कोलाई* प्लास्मिड → अलग से उत्पादित → डाइसल्फ़ाइड बांड द्वारा जुड़े → पहले **ह्यूमुलिन** (मानव-समान पुनः संयोजक इंसुलिन)।',
            },
            {
              english: '**2. Gene therapy** —',
        hindi: '**2. पित्रैक उपचार** -',
            },
            {
              english: '• Correction of genetic defect by transfer of normal gene to replace/supplement defective one.',
        hindi: '• सामान्य जीन को replace/supplement दोषपूर्ण जीन में स्थानांतरित करके आनुवंशिक दोष का सुधार।',
            },
            {
              english: '• First clinical gene therapy (1990) — **4-year-old girl** with **ADA (Adenosine Deaminase) deficiency** → SCID.',
        hindi: '• पहली क्लिनिकल जीन थेरेपी (1990) - **एडीए (एडेनोसिन डेमिनेज) की कमी** के साथ **4 वर्षीय लड़की** → एससीआईडी।',
            },
            {
              english: '• Lymphocytes from patient → grown in culture → functional ADA cDNA introduced via retroviral vector → reinfused. Lymphocytes mortal → repeat infusions. Permanent cure: gene introduced into bone marrow stem cells at early embryonic stage.',
        hindi: '• रोगी से लिम्फोसाइट्स → संस्कृति में विकसित → कार्यात्मक एडीए सीडीएनए रेट्रोवायरल सदिश के माध्यम से पेश किया गया → पुन: संचारित। लिम्फोसाइट्स नश्वर → बार-बार संक्रमण। स्थायी इलाज: प्रारंभिक भ्रूण अवस्था में जीन को अस्थि मज्जा स्टेम कोशिकाओं में डाला गया।',
            },
            {
              english: '**3. Molecular diagnosis** —',
        hindi: '**3. आण्विक निदान** —',
            },
            {
              english: '• Conventional methods (serum/urine analysis, antibody tests) detect after symptoms → too late.',
        hindi: '• पारंपरिक तरीकों (serum/urine विश्लेषण, एंटीबॉडी परीक्षण) से लक्षणों के बाद पता चलता है → बहुत देर से।',
            },
            {
              english: '• **PCR + ELISA + recombinant DNA technology** → very early, sensitive detection.',
        hindi: '• **पीसीआर + एलिसा + पुनः संयोजक डीएनए तकनीक** → बहुत जल्दी, संवेदनशील पहचान।',
            },
            {
              english: '• PCR — used to detect **HIV in suspected AIDS patients**, mutations in **cancer** patients, **mycobacterium TB**.',
        hindi: '• पीसीआर - **संदिग्ध एड्स रोगियों में एचआईवी**, **कैंसर** रोगियों में उत्परिवर्तन, **माइकोबैक्टीरियम टीबी** का पता लगाने के लिए उपयोग किया जाता है।',
            },
            {
              english: '• **ELISA** — based on **antigen-antibody interaction**; enzyme-linked secondary antibody → colour. Detects HIV antibodies.',
        hindi: '• **एलिसा** - **एंटीजन-एंटीबॉडी इंटरेक्शन** पर आधारित; एंजाइम से जुड़े माध्यमिक एंटीबॉडी → रंग। एचआईवी एंटीबॉडी का पता लगाता है।',
            },
          ],
        },
      ],
    },
    {
      id: 'transgenic-animals',
      title: {
        english: 'Transgenic Animals',
        hindi: 'ट्रांसजेनिक जन्तु',
      },
      blocks: [
        {
          type: 'list',
          items: [
            {
              english: 'Animals with manipulated DNA — > **95 % are mice**.',
        hindi: 'हेरफेर किए गए डीएनए वाले जानवर - > **95% चूहे हैं**।',
            },
            {
              english: 'Reasons for development:',
        hindi: 'विकास के कारण:',
            },
            {
              english: '• **Normal physiology study** — insulin-like growth factors.',
        hindi: '• **सामान्य शरीर विज्ञान अध्ययन** - इंसुलिन जैसे विकास कारक।',
            },
            {
              english: '• **Disease models** — for cancer, cystic fibrosis, rheumatoid arthritis, Alzheimer\'s.',
        hindi: '• **रोग मॉडल** - कैंसर, सिस्टिक फाइब्रोसिस, रुमेटीइड गठिया, अल्जाइमर के लिए।',
            },
            {
              english: '• **Biological products** —',
        hindi: '• **जैविक उत्पाद** — - **रोज़ी (1997)** - α-lactalbumin समृद्ध मानव दूध (2.4 ) पैदा करने वाली पहली ट्रांसजेनिक गाय → प्राकृतिक गाय के दूध से अधिक पौष्टिक। - α-1 एंटीट्रिप्सिन (वातस्फीति), फैक्टर VIII (हीमोफिलिया)।',
            },
            {
              english: '  - **Rosie (1997)** — first transgenic cow producing α-lactalbumin enriched human milk (2.4 g/L) → more nutritious than natural cow milk.',
        hindi: '- **रोज़ी (1997)** - α-lactalbumin समृद्ध मानव दूध (2.4 g/L) पैदा करने वाली पहली ट्रांसजेनिक गाय → प्राकृतिक गाय के दूध से अधिक पौष्टिक।',
            },
            {
              english: '  - α-1 antitrypsin (emphysema), Factor VIII (haemophilia).',
        hindi: '- α-1 एंटीट्रिप्सिन (वातस्फीति), फैक्टर VIII (हीमोफिलिया)।',
            },
            {
              english: '• **Vaccine safety testing** — polio vaccine first tested on transgenic mice.',
        hindi: '• **वैक्सीन सुरक्षा परीक्षण** - पोलियो वैक्सीन का पहली बार ट्रांसजेनिक चूहों पर परीक्षण किया गया।',
            },
            {
              english: '• **Chemical safety testing** — toxicity testing similar to humans.',
        hindi: '• **रासायनिक सुरक्षा परीक्षण** — मनुष्यों के समान विषाक्तता परीक्षण।',
            },
          ],
        },
      ],
    },
    {
      id: 'ethics-patents',
      title: {
        english: 'Ethical Issues, Biopatents & Biopiracy',
        hindi: 'नैतिक मुद्दे, जैव-पेटेंट और जैव-चोरी',
      },
      blocks: [
        {
          type: 'list',
          items: [
            {
              english: '**GEAC (Genetic Engineering Approval Committee)** — Indian government body that decides validity of GM research and safety of releasing GMOs for public services.',
        hindi: '**जीईएसी (जेनेटिक इंजीनियरिंग अप्रूवल कमेटी)** - भारत सरकार का निकाय जो जीएम अनुसंधान की वैधता और सार्वजनिक सेवाओं के लिए जीएमओ जारी करने की सुरक्षा का फैसला करता है।',
            },
            {
              english: '**Biopatent** — patent granted for biological entity / its product.',
        hindi: '**बायोपेटेंट** - जैविक इकाई/उसके उत्पाद के लिए पेटेंट प्रदान किया गया।',
            },
            {
              english: '**Biopiracy** — unauthorised use of bio-resources / traditional knowledge by multinational corporations without authorisation / compensation.',
        hindi: '**बायोपाइरेसी** - प्राधिकरण/मुआवजे के बिना बहुराष्ट्रीय निगमों द्वारा जैव-संसाधनों/पारंपरिक ज्ञान का अनधिकृत उपयोग।',
            },
            {
              english: 'Examples of biopiracy fights:',
        hindi: 'बायोपाइरेसी लड़ाई के उदाहरण:',
            },
            {
              english: '• **Basmati rice** — RiceTec Inc. (USA) granted patent (1997) on cross-bred basmati strains; India fought back, patent revoked partly.',
        hindi: '• **बासमती चावल** - राइसटेक इंक (यूएसए) ने क्रॉस-ब्रेड बासमती उपभेदों पर पेटेंट (1997) प्रदान किया; भारत ने प्रतिकार किया, पेटेंट आंशिक रूप से रद्द कर दिया गया।',
            },
            {
              english: '• **Neem** — European patent on antifungal use of neem revoked after India\'s opposition.',
        hindi: '• **नीम** - भारत के विरोध के बाद नीम के एंटीफंगल उपयोग पर यूरोपीय पेटेंट रद्द कर दिया गया।',
            },
            {
              english: '• **Turmeric** — US patent on wound-healing use of turmeric revoked.',
        hindi: '• **हल्दी** - घाव भरने में हल्दी के उपयोग पर अमेरिकी पेटेंट रद्द कर दिया गया।',
            },
            {
              english: 'Indian Parliament has cleared a **second amendment of the Indian Patents Bill** to prevent unauthorised exploitation.',
        hindi: 'भारतीय संसद ने अनधिकृत शोषण को रोकने के लिए **भारतीय पेटेंट विधेयक** के दूसरे संशोधन को मंजूरी दे दी है।',
            },
          ],
        },
      ],
    },
  ],
  keyFormulas: [
    {
      latex: '\\text{Bt toxin: protoxin} \\xrightarrow{\\text{alkaline midgut}} \\text{active toxin}',
      desc: {
        english: '',
        hindi: 'बीटी विष: प्रोटोक्सिन सक्रिय विष',
      },
    },
    {
      latex: '\\text{cryIAc, cryIIAb} \\rightarrow \\text{cotton bollworm; cryIAb} \\rightarrow \\text{corn borer}',
      desc: {
        english: '',
        hindi: 'CryIAc, CryIIAb कॉटन बॉलवर्म; क्रायआईएबी मक्का बेधक',
      },
    },
    {
      latex: '\\text{RNAi: dsRNA silences nematode mRNA in host plant}',
      desc: {
        english: '',
        hindi: 'आरएनएआई: डीएसआरएनए मेजबान पौधे में नेमाटोड एमआरएनए को शांत करता है',
      },
    },
    {
      latex: '\\text{Insulin: A (21 aa) + B (30 aa) + S-S; C-peptide removed}',
      desc: {
        english: '',
        hindi: 'इंसुलिन: ए (21 एए) + बी (30 एए) + एस-एस; सी-पेप्टाइड हटा दिया गया',
      },
    },
    {
      latex: '\\text{Humulin (Eli Lilly, 1983) — first recombinant human insulin}',
      desc: {
        english: '',
        hindi: 'ह्यूमुलिन (एली लिली, 1983) - पहला पुनः संयोजक मानव इंसुलिन',
      },
    },
    {
      latex: '\\text{First gene therapy (1990): ADA deficiency (SCID)}',
      desc: {
        english: '',
        hindi: 'प्रथम जीन थेरेपी (1990): एडीए की कमी (एससीआईडी)',
      },
    },
    {
      latex: '\\text{ELISA: antigen-antibody + enzyme-linked colour reaction}',
      desc: {
        english: '',
        hindi: 'एलिसा: एंटीजन-एंटीबॉडी + एंजाइम-लिंक्ड रंग प्रतिक्रिया',
      },
    },
  ],
  pyqs: [
    {
      year: 2024,
      exam: 'NEET',
      tag: 'Insulin',
      problem: {
        english: 'In recombinant human insulin, A and B chains are joined by:',
        hindi: 'पुनः संयोजक मानव इंसुलिन में, ए और बी श्रृंखलाएं जुड़ती हैं:',
      },
      answer: {
        english: 'Disulphide (S-S) bonds',
        hindi: 'डाइसल्फ़ाइड (S-S) बांड',
      },
      solution: {
        english: 'C-peptide is removed during maturation; chains linked separately in vitro.',
        hindi: 'परिपक्वता के दौरान सी-पेप्टाइड हटा दिया जाता है; इन विट्रो में अलग-अलग जुड़ी हुई शृंखलाएँ।',
      },
    },
    {
      year: 2023,
      exam: 'NEET',
      tag: 'Bt',
      problem: {
        english: 'Cry I Ac gene gives resistance against:',
        hindi: 'Cry I Ac जीन किसके विरुद्ध प्रतिरोध देता है:',
      },
      answer: {
        english: 'Cotton bollworm',
        hindi: 'कपास की सूंडी',
      },
      solution: {
        english: 'cryIAb → corn borer.',
        hindi: 'क्रायआईएबी → मकई छेदक।',
      },
    },
    {
      year: 2022,
      exam: 'NEET',
      tag: 'Therapy',
      problem: {
        english: 'First disease treated by gene therapy was:',
        hindi: 'जीन थेरेपी द्वारा इलाज किया गया पहला रोग था:',
      },
      answer: {
        english: 'ADA deficiency (SCID)',
        hindi: 'एडीए की कमी (एससीआईडी)',
      },
      solution: {
        english: '4-year-old girl, 1990.',
        hindi: '4 वर्षीय लड़की, 1990।',
      },
    },
    {
      year: 2021,
      exam: 'NEET',
      tag: 'Diagnosis',
      problem: {
        english: 'ELISA is based on:',
        hindi: 'एलिसा इस पर आधारित है:',
      },
      answer: {
        english: 'Antigen-antibody interaction',
        hindi: 'एंटीजन-एंटीबॉडी इंटरैक्शन',
      },
      solution: {
        english: 'Enzyme-linked secondary antibody produces colour.',
        hindi: 'एंजाइम-लिंक्ड सेकेंडरी एंटीबॉडी रंग पैदा करता है।',
      },
    },
    {
      year: 2019,
      exam: 'NEET',
      tag: 'Bt mode',
      problem: {
        english: 'Bt toxin protein crystals exist as inactive protoxin because:',
        hindi: 'बीटी टॉक्सिन प्रोटीन क्रिस्टल निष्क्रिय प्रोटॉक्सिन के रूप में मौजूद होते हैं क्योंकि:',
      },
      answer: {
        english: 'Insect alkaline midgut activates them',
        hindi: 'कीट क्षारीय मध्य आंत उन्हें सक्रिय करता है',
      },
      solution: {
        english: 'Bacterium itself does not get killed by its own toxin.',
        hindi: 'जीवाणु स्वयं अपने विष से नहीं मरता।',
      },
    },
  ],
  next: {
    slug: 'microbes-human-welfare',
    title: 'Microbes in Human Welfare',
  },
};

export default chapter;
